<template>
<div id="reservations" :class="{'pa-2 ma-2': $vuetify.breakpoint.smAndUp}" style="padding-bottom: 70px !important">
    <!-- reservations card -->
    <v-container fluid>

        <router-view :hotel="hotel" :reservation_id="reservation.id" :dialog="dialog_reservation" @exit="backToReservations()"></router-view>

        <im-filters :hotel_id="hotel.id" @filter="filterResevations($event)" @search="searchRerersation($event)" @fields="updateFields($event)"></im-filters>

        <!--data table-->
        <v-card tile flat>
            <im-table-header :items="im_header" @clickSort="sortItems($event)" />
        </v-card>
        <!--./ data table -->
        <div class="" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>
        <template v-if="items.length > 0">
            <!-- DATATABLE ROWS -->
            <v-card tile flat style="background-color: transparent !important;">
                <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                    <template v-slot:item="props">
                        <im-reservation-item :item="props.item" @click.native="seeReservation(props.item)"></im-reservation-item>
                    </template>
                </v-data-iterator>
            </v-card>
        </template>
        <div v-else>
            <div class="important pa-2 text-center">
                {{ $t('reservations.table_message') }}
            </div>
        </div>
    </v-container>
    <!-- ./ reservations card -->

    <!-- print components -->
    <im-print-list class="printMe" :items="items" ref="print-list" />
    <im-print-modal class="printMe" :reservation_id="reservation.id" id="print-item" />
    <!--./ print components -->

    <im-download type="xls" name="reservations.xls" :fields="im_excel_header" ref="reservation"></im-download>

    <im-footer>
        <div slot="right">
            <v-btn :small="$vuetify.breakpoint.smAndDown" color="primary" @click="getDownloadReservations()">
                Export Excel
            </v-btn>
            <v-btn v-if="$vuetify.breakpoint.smAndUp" :small="$vuetify.breakpoint.smAndDown" class="mx-1" color="primary" @click="printList()">
                {{ $t('reservations.button.print_list') }}
            </v-btn>
        </div>
    </im-footer>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import qs from "qs";
import defaults from "../../components/utils/PropDefaults.js";
import Download from "../../components/utils/Download.vue";
import IMTableHeader from '../../components/utils/IMTableHeader.vue';
import IMReservationItem from '../../components/items/Reservations/Card.vue';
import IMFilters from '../../components/items/Reservations/Filters.vue';
import IMFooter from '../../components/utils/IMFooter.vue';
import IMListReservations from '../../components/utils/print/ListReservations.vue';
import IMItemReservations from '../../components/utils/print/ItemReservation.vue';

export default {
    name: `reservations`,
    props: ['hotel'],

    components: {
        'im-download': Download,
        'im-filters': IMFilters,
        'im-table-header': IMTableHeader,
        'im-reservation-item': IMReservationItem,
        'im-print-list': IMListReservations,
        'im-print-modal': IMItemReservations,
        "im-footer": IMFooter,
    },

    data() {
        return {
            reservation: this.$clone(defaults.reservation_item),
            fields: [],
            print: false,
            room_types: [],
            rate_plans: [],
            // dialog
            dialog_reservation: false,
            dialog_reservation_status: false,
            comment: false,
            status_loading: false,

            filters: {
                hotel_id: null,
                room_type_id: null,
                rate_plan_id: null,
                status: null,
                timestamp: {
                    before: null,
                    after: null,
                },
                check_in: {
                    before: null,
                    after: null,
                },
                check_out: {
                    before: null,
                    after: null,
                },
            },

            // search
            search: null,
            search_timeout: 300,
            // table items
            items: [],
            loading: false,
            total: 0,
            page: 1,
            size: 5,
            itemsPerPageOptions: [5, 10, 15, 25],

            im_excel_header: {
                'Booking Code': 'external_id',
                'Status': 'status',
                'Platforma': 'channel',
                'Nume hotel': 'hotel_name',
                'Localitate hotel': 'hotel_city',
                'Creat': 'created_at',
                'Check-In': 'check_in',
                'Check-Out': 'check_out',
                'Nopti': 'nights',
                'Pret total': 'pricing.total',
                'Moneda': 'pricing.currency',
                'Camere': 'rooms_name',
                'Nume client': 'customer.last_name',
                'Prenume client': 'customer.first_name',
                'Email client ': 'customer.contact.email',
                'Client telefon': 'customer.contact.phone',
            }
        };
    },

    computed: {
        // imemento table
        im_header() {
            return [
                {
                    text: this.$t('reservations.table_header.booking_date'),
                    width: "16.66%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: this.$t('reservations.table_header.client_name'),
                    width: "25%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: this.$t('reservations.table_header.room_details'),
                    width: "29%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: "CI",
                    width: "3%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: "CO",
                    width: "3%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: this.$t('reservations.table_header.price'),
                    width: "13.34%",
                    align: "right",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: this.$t('reservations.table_header.payment'),
                    width: "10%",
                    align: "center",
                    sortable: false,
                    sort_dir: null,
                },
            ]
        },

    },

    watch: {
        '$route.params.hotel_slug': {
            async handler() {
                await this.hotel
                // react to route changes...
                if(this.$route.params.hotel_slug !== this.hotel.slug) {
                    await this.checkSlug(this.$route.params.hotel_slug)
                    this.getAllItems();
                } else {
                    this.getAllItems();
                }
            },
            deep: true,
            immediate: true
        },

        page: {
            handler() {
                if(!this.hotel.id) {
                    return;
                }
                this.getItems();
            }
        },
        size: {
            handler() {
                if(!this.hotel.id) {
                    return;
                }
                this.getItems();
            }
        },
        search: {
            handler() {
                this.page = 1;
                if(!this.hotel.id) {
                    return;
                }
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 500);
            }
        },
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        checkSlug(slug) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/check-slug";
            let params = {
                params: {
                    slug: slug
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.exists) {
                        this.$emit('changeHotel', [response.data.hotel_id, false]);
                    } else {
                        this.error("Oops, something went wrong!");
                        this.$router.push({
                            path: '/dashboard',
                        });
                    }
                    return new Promise(function (resolve, reject) {
                        resolve(true);
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
        },

        getAllItems() {
            if(!this.hotel.id) {
                return;
            }
            this.getItems();
        },

        getItems() {
            if(!this.hotel.id) {
                return
            }

            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }

            // prepare stamp
            let stamp = Date.now();

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/reservations';

            // setup query params
            let options = {
                params: {
                    size: this.size,
                    page: this.page,
                    query: search,
                    hotel_id: this.hotel.id,
                    search_fields: this.fields,
                    status: this.filters.status,
                    room_type_id: this.filters.room_type_id,
                    rate_plan_id: this.filters.rate_plan_id,
                    created_at: {
                        from: this.filters.timestamp.after,
                        until: this.filters.timestamp.before
                    },
                    check_in: {
                        from: this.filters.check_in.after,
                        until: this.filters.check_in.before
                    },
                    check_out: {
                        from: this.filters.check_out.after,
                        until: this.filters.check_out.before
                    },
                },
                paramsSerializer: qs.stringify
            };

            this.$axios.get(endpoint, options)
                .then(response => {
                    this.items = response.data.data;
                    this.total = response.data.pagination.total;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        noShow(value_id) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/reservations/no-show';

            let reservation = {
                id: value_id,
                sync: true
            }

            this.$axios.post(endpoint, reservation)
                .then(response => {
                    this.getItems();
                })
                .catch(error => {
                    this.error('Ooops, something went wrong!');
                    console.log(error);
                })
                .finally(() => {
                    this.dialog_reservation_status = false
                });
        },

        seeReservation(current_reservation) {
            this.reservation = this.$clone(current_reservation);
            this.dialog_reservation = true;
            this.$router.push({
                path: '/' + this.hotel.slug + '/reservations/' + current_reservation.id
            });
        },

        backToReservations() {
            this.$router.back();
        },

        formatDate(value) {
            if(!value) return value;
            return this.$moment(String(value))
                .locale(this.$vuetify.lang.current)
                .format('D MMM YY');
        },

        checkNoShow(check_in, check_out, status) {
            let lower_bound_moment = this.$moment(check_in.split(' ')[0])
                .add(1, 'day');

            let upper_bound_moment = this.$moment(check_out.split(' ')[0])
                .add(1, 'month')
                .date(5);

            let today = this.$moment();

            return (status == 'booked') && lower_bound_moment.isBefore(today) && upper_bound_moment.isAfter(today);

        },

        printReservation(divPrint) {
            let elem = document.getElementById(divPrint);
            let domClone = elem.cloneNode(true);
            let printSection = document.getElementById("printSection");

            if(!printSection) {
                printSection = document.createElement("div");
                printSection.id = "printSection";
                printSection.innerHTML = "";
                printSection.appendChild(domClone);
                document.body.appendChild(printSection);
            } else {
                printSection.innerHTML = "";
                printSection.appendChild(domClone);
            }
            window.print();
        },

        searchRerersation(value) {
            this.search = value;
            this.page = 1;
            this.getItems();
        },

        updateFields(value) {
            this.fields = value;
            if(this.search) {
                this.page = 1;
                this.getItems();
            }
        },

        filterResevations(value) {
            this.filters = value;
            this.page = 1;
            this.getItems();
        },

        filterItems() {
            this.page = 1;
            this.getItems();
        },

        printList() {
            let elem = document.getElementById('list-reservations');
            let domClone = elem.cloneNode(true);
            let printSection = document.getElementById("printSection");

            if(!printSection) {
                printSection = document.createElement("div");
                printSection.id = "printSection";
                printSection.innerHTML = "";
                printSection.appendChild(domClone);
                document.body.appendChild(printSection);
            } else {
                printSection.innerHTML = "";
                printSection.appendChild(domClone);
            }
            window.print();

        },

        getDownloadReservations() {

            let excel_items = this.items.map(function (item, index) {
                item.check_in = item.check_in.split(" ")[0];
                item.check_out = item.check_out.split(" ")[0];
                item.created_at = item.created_at.split(" ")[0];
                if(item.customer.contact.phone === null) {
                    item.customer.contact.phone = "";
                } else {
                    item.customer.contact.phone = `​${item.customer.contact.phone}`
                }
                if(item.status === "booked" || item.status === "modified") {
                    item.status = "Rezervat";
                }
                if(item.status === "no-show") {
                    item.status = "Neprezentat";
                }
                if(item.status === "canceled") {
                    item.status = "Anulat";
                }
                if(item.channel == 'Q-Travel') {
                    item.channel = "Christian Tour"
                }
                item.rooms_name = item.rooms.map(room => room.room_type.name)
                return item
            })

            this.$refs.reservation.generate(excel_items);

        }
    }
}
</script>

<style>
.im-select.truncate .v-select__selection--comma {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
}



@media only screen and (max-width: 400px) {
    .im-select.truncate .v-select__selection--comma {
        max-width: 100px;
    }
}

@media only screen and (max-width: 550px) and (min-width: 401px) {
    .im-select.truncate .v-select__selection--comma {
        max-width: 140px;
    }
}

.printMe {
    display: none;
    width: 100%;
    max-width: 1500px;
}


@media screen {
    #printSection {
        display: none;
    }
}

@media print {
    @page {
        size: A4;
        page-break-after: avoid;
    }

    body * {
        line-height: 1 !important;
        visibility: hidden;
        page-break-after: avoid;
    }

    #app {
        top: 0;
        height: 0px;
        max-height: 0px;
        display: none;
        position: absolute;
    }

    #printSection,
    #printSection * {
        visibility: visible;
    }

    #printSection {
        /* min-height: auto; */
        position: absolute;
        left: 0;
        top: 0;
        width: auto;
        page-break-after: avoid;
        /* page-break-inside: avoid; */
        width: 100% !important;
        max-width: 100% !important;
    }

    .printMe {
        display: block;
        width: 100%;
        /* height: 100%; */
        page-break-after: avoid;
    }

    #list-reservations .im-result {
        page-break-inside: avoid;
    }

    #printSection .im-room {
        page-break-after: avoid;
        page-break-inside: avoid;
    }
}
</style>
